import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { imgPDF } from "./constantsPDF";
import moment from "moment";

export default class RequestPDF {
  generatePDF(data) {
    const arrFamilia = this.orgInArray(
      data.familias,
      "nombreCompleto",
      "parentesco",
      "fechaNacimiento",
      "edad",
      "ocupacion"
    );
    const arrEducacion = this.orgInArray(
      data.educacion,
      "nivelAcademico",
      "nombreInstitucion",
      "fechaInicio",
      "fechaFinal",
      "titulo"
    );

    const arrlaboral = this.orgInArray(
      data.experienciaLaborals,
      "empresa",
      "fechaInicio",
      "fechaFinal",
      "puesto",
      "salario",
      "supervisor"
    );
    
    const arrReferencia = this.orgInArray(
      data.referencias,
      "nombreCompleto",
      "direccion",
      "tiempoConociendolo"
    );

    const arrReferencialab = this.orgInArray(
      data.referenciasLabs,
      "nombreCompleto",
      "cargo",
      "telefono"
    )
    

    const parientes = this.concatObj(data.parientes, "nombreCompleto");
    const amigos = this.concatObj(data.amigos, "nombreCompleto");
    const software = this.concatObj(data.equipoSoftwares, "descripcion");

    const arrIdiomas = this.orgInArray(
      data.idiomas,
      "nombre",
      "lectura",
      "escritura",
      "habla"
    );

    const arrEmergencia = this.orgInArray(
      data.emergencias,
      "nombreCmpleto",
      "telefono",
      "parentesco"
    );

    var doc = {
      pageMargins: [20, 25, 20, 25],
      content: [
        {
          table: {
            widths: [190, "*"],
            body: [
              [
                {
                  image: imgPDF,
                  width: 180,
                },
                { text: "SOLICITUD DE EMPLEO", style: "title" },
              ],
            ],
          },
        },
        {
          style: "tablePhoto",
          table: {
            widths: [135, 45, "*"],
            body: [
              [
                { rowSpan: 2, text: "Foto", style: "photo" },
                { rowSpan: 2, border: [false, false, false, false], text: "" },
                { text: "PARA USO DE GESTION HUMANA", style: "textCenter" },
              ],
              [
                "",
                "",
                [
                  { text: `POSICION: ${data.vacante == null ? "" : data.vacante.nombre}`, margin: [0, 0, 0, 5] },
                  { text: "SUELDO:", margin: [0, 0, 0, 5] },
                  { text: "FECHA DE INGRESO:", margin: [0, 0, 0, 5] },
                  { text: "SUCURSAL:", margin: [0, 0, 0, 5] },
                  { text: "OBSERVACIONES:", margin: [0, 0, 0, 5] },
                ],
              ],
            ],
          },
        },
        {
          style: "tableCustome",
          table: {
            widths: ["*", "*", 95],
            body: [
              [
                {
                  color: "#ffffff",
                  bold: true,
                  text: "DATOS PERSONALES",
                  alignment: "center",
                  colSpan: 3,
                  fillColor: "#03833d",
                },
                {},
                {},
              ],
              
            ],
          },
        },
        {
          style: "tablePhoto",
          table: {
            widths: [50, "*", 55, "*"],
            body: [
              
              [
                { border: [false, false], text: "NOMBRES:" },
                {
                  text:
                    data.solicitud.nombre == null ? "" : data.solicitud.nombre,
                  border: [false, false, false, true],
                },
                { text: "APELLIDOS:", border: [false, false] },
                {
                  text:
                    data.solicitud.apellido == null
                      ? ""
                      : data.solicitud.apellido,
                  border: [false, false, false, true],
                },
              ],
            ],
          },
        },
        {
          style: "tableComplete",
          table: {
            widths: [83, 80, 50, 85, 40, "*"],
            body: [
              [
                { border: [false, false], text: "TELÉFONO CASA:" },
                {
                  text:
                    data.solicitud.telefono == null
                      ? ""
                      : data.solicitud.telefono,
                  border: [false, false, false, true],
                },
                { text: "CELULAR:", border: [false, false] },
                {
                  text:
                    data.solicitud.celular == null
                      ? ""
                      : data.solicitud.celular,
                  border: [false, false, false, true],
                },
                { text: "E-MAIL:", border: [false, false] },
                {
                  text:
                    data.solicitud.correo == null ? "" : data.solicitud.correo,
                  border: [false, false, false, true],
                },
              ],
            ],
          },
        },
        {
          style: "tableComplete",
          table: {
            widths: [60, "*"],
            body: [
              [
                { border: [false, false], text: "DIRECCIÓN:" },
                {
                  text:
                    data.solicitud.direccion == null
                      ? ""
                      : data.solicitud.direccion,
                  border: [false, false, false, true],
                },
              ],
            ],
          },
        },
        {
          style: "tableComplete",
          table: {
            widths: [115, "*", 98, 100],
            body: [
              [
                {
                  border: [false, false],
                  text: "LUGAR DE NACIMIENTO:",
                },
                {
                  text:
                    data.solicitud.lugarNacimiento == null
                      ? ""
                      : data.solicitud.lugarNacimiento,
                  border: [false, false, false, true],
                },
                { text: "FECHA NACIMIENTO:", border: [false, false] },
                {
                  text:
                    data.solicitud.fechaNacimento == null
                      ? ""
                      : moment(data.solicitud.fechaNacimento).format("DD/MM/yyyy"),
                  border: [false, false, false, true],
                },
              ],
            ],
          },
        },
        {
          style: "tableComplete",
          table: {
            widths: [70, 60, 80, 70, 105, "*"],
            body: [
              [
                { border: [false, false], text: "ESTADO CIVIL:" },
                {
                  text:
                    data.solicitud.estadoCivil == null
                      ? ""
                      : data.solicitud.estadoCivil,
                  border: [false, false, false, true],
                },
                { text: "TIPO DE SANGRE:", border: [false, false] },
                {
                  text:
                    data.solicitud.tipoSangre == null
                      ? ""
                      : data.solicitud.tipoSangre,
                  border: [false, false, false, true],
                },
                { text: "CÉDULA / PASAPORTE:", border: [false, false] },
                {
                  text:
                    data.solicitud.documento == null
                      ? ""
                      : data.solicitud.documento,
                  border: [false, false, false, true],
                },
              ],
            ],
          },
        },
        {
          style: "tableCustome",
          table: {
            widths: ["*", 100, 80, 40, "*"],
            body: [
              [
                {
                  color: "#ffffff",
                  bold: true,
                  text: "DATOS FAMILIARES (ESPOSO/A, HIJOS/AS):",
                  alignment: "center",
                  colSpan: 5,
                  fillColor: "#03833d",
                },
                {},
                {},
                {},
                {},
              ],
              [
                { text: "NOMBRE(S) Y APELLIDO(S)", bold: true },
                { text: "PARENTESCO", bold: true },
                { text: "FECHA DE NACIMIENTO", bold: true },
                { text: "EDAD", bold: true },
                { text: "OCUPACIÓN", bold: true },
              ],
              ...arrFamilia,
            ],
          },
        },
        {
          style: "tableCustome",
          table: {
            widths: [90, 127, 70, 70, "*"],
            body: [
              [
                {
                  color: "#ffffff",
                  bold: true,
                  text: "EDUCACIÓN",
                  alignment: "center",
                  colSpan: 5,
                  fillColor: "#03833d",
                },
                {},
                {},
                {},
                {},
              ],
              [
                { text: "NIVEL", bold: true },
                { text: "NOMBRE INSTITUCIÓN", bold: true },
                { text: "DESDE", bold: true },
                { text: "HASTA", bold: true },
                { text: "NIVEL FINAL / TÍTULO OBTENIDO", bold: true },
              ],
              ...arrEducacion,
            ],
          },
        },
        {
          style: "tableCustome",
          table: {
            widths: [100,65,65,70,70,"*"],
            body: [
              [
                {
                  color: "#ffffff",
                  bold: true,
                  text:
                    "CARGOS DESEMPEÑADOS (DETALLAR CRONOLÓGICAMENTE ÚLTIMOS 3):",
                  alignment: "center",
                  colSpan: 6,
                  fillColor: "#03833d",
                },
                {},
                {},
                {},
                {},
                {}
              ],
              [
                { text: "EMPRESA", bold: true },
                { text: "DESDE", bold: true },
                { text: "HASTA", bold: true },
                { text: "CARGO", bold: true },
                { text: "SALARIO", bold: true },
                { text: "JEFE INMEDIATO", bold: true },
              ],
              ...arrlaboral,
            ],
          },
        },
        {
          style: "tableCustome",
          table: {
            widths: ["*", "*", 95],
            body: [
              [
                {
                  color: "#ffffff",
                  bold: true,
                  text: "REFERENCIAS LABORALES ULTIMOS 3:",
                  alignment: "center",
                  colSpan: 3,
                  fillColor: "#03833d",
                },
                {},
                {},
              ],
              [
                { text: "NOMBRE", bold: true },
                { text: "CARGO", bold: true },
                { text: "TIEMPO QUE CONOCE", bold: true },
              ],
              ...arrReferencialab,
            ],
          },
        },
        {
          style: "tableCustome",
          table: {
            widths: ["*", "*", 95],
            body: [
              [
                {
                  color: "#ffffff",
                  bold: true,
                  text: "REFERENCIAS PERSONALES DE 2 PERSONAS (NO FAMILIARES):",
                  alignment: "center",
                  colSpan: 3,
                  fillColor: "#03833d",
                },
                {},
                {},
              ],
              [
                { text: "NOMBRE", bold: true },
                { text: "DIRECCIÓN Y TELÉFONOA", bold: true },
                { text: "TIEMPO QUE CONOCE", bold: true },
              ],
              ...arrReferencia,
            ],
          },
        },
        { text: "", margin: [0, 20] },
        {
          table: {
            widths: [110,"*"],
           
            body: [
              [
                {
                  style: "tableCustome",
                  color: "#ffffff",
                  bold: true,
                  text: "EN CASO DE SER CONTRATADO Y SU POSICIÓN APLIQUE PARA EL USO DE UNIFORMES",
                  alignment: "center",
                  fillColor: "#03833d",
                  colSpan:2
                }
              ],
              [
                { border: [true, false,false, true],  text: "BATA DE LABORATORIO:" },
                { text: "", border: [false, false, true, true] },
              ],
              [
                { border: [true, false,false, true], text: "SIZE CAMISA:" },
                { text: "", border: [false, false, true, true] },
              ],
              [
                { border: [true, false, false, true], text: "SIZE PANTALÓN:" },
                { text: "", border: [false, false, true, true] },
              ]
              
            ],
          },
        },
        {
          text:
            "NOMBRES DE PARIENTES QUE LABORAN EN REFERENCIA, ACTUAL O ANTERIORMENTE:",
          margin: [0, 15, 0, 0],
        },
        {
          style: "tableComplete",
          table: {
            widths: ["*"],
            body: [[{ border: [false, false, false, true], text: parientes }]],
          },
        },
        {
          text: "NOMBRES DE AMIGOS QUE LABORAN EN REFERENCIA:",
          margin: [0, 15, 0, 0],
        },
        {
          style: "tableComplete",
          table: {
            widths: ["*"],
            body: [[{ border: [false, false, false, true], text: amigos }]],
          },
        },
        { text: "QUIEN LO RECOMIENDA?", margin: [0, 15, 0, 0] },
        {
          style: "tableComplete",
          table: {
            widths: ["*"],
            body: [
              [
                {
                  border: [false, false, false, true],
                  text:
                    data.solicitud.recomendacion == null
                      ? " "
                      : data.solicitud.recomendacion,
                },
              ],
            ],
          },
        },
        { text: "QUE TRABAJO O AREA PREFIERE?", margin: [0, 15, 0, 0] },
        {
          style: "tableComplete",
          table: {
            widths: ["*"],
            body: [
              [
                {
                  border: [false, false, false, true],
                  text:
                    data.solicitud.areaPrefiere == null
                      ? " "
                      : data.solicitud.areaPrefiere,
                },
              ],
            ],
          },
        },
        {
          text: "CUALES EQUIPOS Y SOFTWARES DE COMPUTADORA MANEJA?",
          margin: [0, 15, 0, 0],
        },
        {
          style: "tableComplete",
          table: {
            widths: ["*"],
            body: [[{ border: [false, false, false, true], text: software }]],
          },
        },
        {
          style: "tableCustome",
          table: {
            widths: ["*", "*", "*", "*"],
            body: [
              [
                {
                  color: "#ffffff",
                  bold: true,
                  text: "CUALES IDIOMAS, ADEMÁS DE ESPAÑOL, USTED DOMINA:",
                  alignment: "center",
                  colSpan: 4,
                  fillColor: "#03833d",
                },
                {},
                {},
                {},
              ],
              [
                { text: "Idioma", bold: true },
                { text: "LEE", bold: true },
                { text: "ESCRIBE", bold: true },
                { text: "HABLA", bold: true },
              ],
              ...arrIdiomas,
            ],
          },
        },
        { text: "POSEE VEHÍCULO?", margin: [0, 15, 0, 0] },
        {
          style: "tableComplete",
          table: {
            widths: [40, "*", 30, "*", 30, "*"],
            body: [
              [
                { border: [false, false], text: "MARCA:" },
                {
                  text: data.vehiculo == null ? "" : (data.vehiculo.marca == null ? "" : data.vehiculo.marca),
                  border: [false, false, false, true],
                },
                { text: "TIPO:", border: [false, false] },
                {
                  text: data.vehiculo == null ? "" : (data.vehiculo.tipo == null ? "" : data.vehiculo.tipo),
                  border: [false, false, false, true],
                },
                { text: "AÑO:", border: [false, false] },
                {
                  text: data.vehiculo == null ? "" : (data.vehiculo.ano == null ? "" : data.vehiculo.ano),
                  border: [false, false, false, true],
                },
              ],
            ],
          },
        },
        {
          style: "tableComplete",
          table: {
            widths: [70, "*", 60, "*", 110, 70],
            body: [
              [
                { border: [false, false], text: "NO. LICENCIA:" },
                {
                  text:
                  data.vehiculo == null ? "" : ( data.vehiculo.licencia == null
                      ? ""
                      : data.vehiculo.licencia),
                  border: [false, false, false, true],
                },
                { text: "CATEGORÍA:", border: [false, false] },
                {
                  text:
                  data.vehiculo == null ? "" : (data.vehiculo.categoria == null
                      ? ""
                      : data.vehiculo.categoria),
                  border: [false, false, false, true],
                },
                { text: "FECHA VENCIMIENTO:", border: [false, false] },
                {
                  text:
                  data.vehiculo == null ? "" : (data.vehiculo.fechaVencimiento == null
                      ? ""
                      : moment(data.vehiculo.fechaVencimiento).format(
                          "DD/MM/yyyy"
                        )),
                  border: [false, false, false, true],
                },
              ],
            ],
          },
        },

        {
          style: "tableCustome",
          table: {
            widths: ["*", "*", "*"],
            body: [
              [
                {
                  color: "#ffffff",
                  bold: true,
                  text: "EN CASO DE EMERGENCIA NOTIFÍCAMOS A",
                  alignment: "center",
                  colSpan: 3,
                  fillColor: "#03833d",
                },
                {},
                {},
              ],
              [
                { text: "NOMBRE", bold: true },
                { text: "TELEFONO", bold: true },
                { text: "PARENTESCO", bold: true },
              ],
              ...arrEmergencia,
            ],
          },
        },
        { text: "", margin: [0, 5] },
        {
          style: "tableComplete",
          table: {
            widths: [40, 70, 130, "*"],
            body: [
              [
                { border: [false, false], text: "FECHA:" },
                {
                  text: moment(data.solicitud.created).format("DD/MM/yyyy"),
                  border: [false, false, false, true],
                },
                { text: "NOMBRE DEL SOLICITANTE:", border: [false, false] },
                {
                  text: `${
                    data.solicitud.nombre == null ? "" : data.solicitud.nombre
                  }  ${
                    data.solicitud.apellido == null
                      ? ""
                      : data.solicitud.apellido
                  }`,
                  border: [false, false, false, true],
                },
              ],
            ],
          },
        },
        { text: "", margin: [0, 5] },

        {
          style: "tableComplete",
          table: {
            widths: ["*"],
            body: [
              [
                {
                  color: "#ffffff",
                  bold: true,
                  text: "PARA USO DE RECLUTAMIENTO Y SELECCIÓN",
                  alignment: "center",
                  fillColor: "#03833d",
                },
              ],
            ],
          },
        },

        {
          style: "tableComplete",
          table: {
            widths: [100, "*", 40, 70],
            body: [
              [
                { border: [false, false], text: "ENTREVISTADO POR:" },
                { text: "", border: [false, false, false, true] },
                { text: "FECHA:", border: [false, false] },
                { text: "", border: [false, false, false, true] },
              ],
            ],
          },
        },
        { text: "", margin: [0, 5] },

        {
          style: "tableComplete",
          table: {
            widths: [84, "*"],
            body: [
              [
                { border: [false, false], text: "OBSERVACIONES:" },
                { text: "", border: [false, false, false, true] },
              ],
            ],
          },

        },
        { text: "", margin: [0, 10] },

//pie de pagina inicio

{
  columns: [
    {
      fontSize:9,
      style:'bigger',
      width: '*',
      text: 'Formulario Solicitud de Empleo \nCódigo F-33-002_02_v3 \nFecha de Emisión: 17/02/2023 \nFecha de Resvisión: 07/07/2023'
    },
    {
    
       width: 185,
      image: imgPDF
    },
   
    {
      fontSize:9,
      style:'bigger',
      width: '*',
      text:'Aprobado por: Amarilis Durán \nRevisado por: Johanny Núñez \nElaborado por: Gestion Humana \nPág. 2 de 2'
    }
  ],
  columnGap: 40
},

//pie de pagina fina 

      ],

      defaultStyle: {
        fontSize: 10,
      },

      styles: {
        title: {
          fontSize: 13,
          bold: true,
          alignment: "center",
          margin: [0, 15, 0, 0],
        },
        tablePhoto: {
          margin: [0, 12, 0, 0],
        },
        tableComplete: {
          margin: [0, 7, 0, 0],
        },
        photo: {
          margin: [0, 45, 0, 0],
          alignment: "center",
        },

        tableCustome: {
          margin: [0, 15, 0, 0],
          alignment: "center",
        },

        textCenter: {
          alignment: "center",
          fontSize: 11,
          bold: true,
        },
      },
    };

    pdfMake.createPdf(doc).download();
  }

  orgInArray(data, ...arg) {
    var result = [];
    if (data.length == 0) {
      let row = [];
      arg.forEach((element) => {
        row.push(" ");
      });
      result.push(row);
      return result;
    }
    data.forEach((value) => {
      let row = [];
      arg.forEach((head) => {
        if (head.includes("fecha")) {
          row.push(moment(value[head]).format("DD/MM/yyyy"));
        } else {
          row.push(value[head]);
        }
      });
      result.push(row);
    });
    return result;
  }

  concatObj(data, property) {
    var result = [];
    data.forEach((element) => {
      result.push(element[property]);
    });
    return result.join(", ");
  }
}
